// extracted by mini-css-extract-plugin
export default {"form":"create-petition_form__xvt8a","col":"create-petition_col__a2ISh","formSection":"create-petition_formSection__8Y5+R"};